import { Button } from '@sr/ui-library';
import { twMerge } from 'tailwind-merge';

interface IConfirmButtonsProps extends React.ComponentProps<'div'> {
  cancelButtonProps?: React.ComponentProps<typeof Button>;
  hasCancelButton?: boolean;
  hasSaveButton?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  saveButtonProps?: Omit<
    React.ComponentProps<typeof Button>,
    'disabled' | 'loading'
  >;
}

export const ConfirmButtons = ({
  cancelButtonProps,
  className,
  hasCancelButton,
  hasSaveButton = true,
  isDisabled,
  isLoading,
  saveButtonProps,
  ...props
}: IConfirmButtonsProps) => (
  <div
    {...props}
    className={twMerge('flex justify-center gap-4 max-sm:flex-col', className)}
  >
    {hasCancelButton && (
      <Button
        {...{
          variant: 'outline',
          ...cancelButtonProps,
        }}
      >
        {cancelButtonProps?.children ?? 'Cancel'}
      </Button>
    )}

    {hasSaveButton && (
      <Button
        {...{
          type: 'submit',
          ...saveButtonProps,
        }}
        disabled={isDisabled || isLoading}
        loading={isLoading}
      >
        {saveButtonProps?.children ?? 'Save'}
      </Button>
    )}
  </div>
);
